export default __webpack_public_path__ + "static/media/submachine-guns.a7af196c.svg";